import { Box, styled } from '@mui/system';
import { CardContent, Typography } from '@mui/material';
import { Key as KeyIcon } from '@mui/icons-material';

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3)
}));

export const HeaderLeft = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const EmptyStateCard = styled(CardContent)(({ theme }) => ({
  textAlign: 'center',
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4)
}));

export const EmptyStateIcon = styled(KeyIcon)(({ theme }) => ({
  fontSize: 48,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2)
}));

export const CardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const StyledCardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2)
}));

export const StyledCardContent = styled(Box)(() => ({
  flex: 1,
  minWidth: 0
}));

export const LabelText = styled(Typography)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
}));

export const APIKeyText = styled(Typography)(({ theme }) => ({
  fontFamily: 'monospace',
  marginBottom: theme.spacing(1)
}));

export const DateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const ExpireContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
